import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/hongyou/background_ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getNoticeList, getNoticeInfo, updateNoticeInfo } from '@/api/mssage';
import { mapGetters } from 'vuex';
// import TopSearch from '@/components/topSearch/index.vue'
// import moment from 'moment'
export default {
  name: 'MessageNotice',
  // components: { TopSearch },
  props: {},
  data: function data() {
    return {
      drawer: false,
      noticeList: [],
      searchList: [],
      btnList: [{
        label: '刷新',
        name: 'refresh',
        handleClick: this.refreshList
      }],
      alarmCount: 0,
      queryParams: {
        pageIndex: 0,
        pageSize: 5
      },
      loading: false,
      count: [],
      notice: "\n            UniqueId int64 'json:\"uniqueId,omitempty\"'\n            Id int64 'json:\"id,omitempty\"'\n            DeptId int64 'json:\"deptId,omitempty\"' // \u5355\u4F4DID\n            Level uint 'json:\"level,omitempty\"' // \u4FE1\u606F\u4F18\u5148\u7EA7\u522B\n            SendTitle string 'json:\"sendTitle,omitempty\"' // \u4E0B\u53D1\u4E3B\u9898\n            SendContent string 'json:\"sendContent,omitempty\"' // \u4E0B\u53D1\u5185\u5BB9\u6587\u672C\n            SendDept string 'json:\"sendDept,omitempty\"' // \u4E0B\u53D1\u5355\u4F4D\u4FE1\u606F\n            SendTime int64 'json:\"sendTime,omitempty\"' //\n            RecvContent string 'json:\"recvContent,omitempty\"' // \u56DE\u590D\u5185\u5BB9\u6587\u672C\n            RecvName string 'json:\"recvName,omitempty\"' // \u56DE\u590D\u4EBA\n            RecvTime int64 'json:\"recvTime,omitempty\"' // \u56DE\u590D\u65E5\u671F\n            RecvStatus uint 'json:\"recvStatus,omitempty\"' // \u5DF2\u56DE\u590D\u6807\u8BB0 0 :\u672A\u64CD\u4F5C\uFF0C 1\uFF1A\u5DF2\u8BFB\u672A\u56DE\u590D\uFF0C 2 \u5DF2\u8BFB\u5DF2\u56DE\u590D\n            CreatedAt int64 'json:\"createdAt,omitempty\"'\n            UpdatedAt int64 'json:\"updatedAt,omitempty\"'\n        ",
      colors: [{
        color: '#f56c6c',
        percentage: 20
      }, {
        color: '#e6a23c',
        percentage: 40
      }, {
        color: '#5cb87a',
        percentage: 60
      }, {
        color: '#1989fa',
        percentage: 80
      }, {
        color: '#6f7ad3',
        percentage: 100
      }],
      list: {
        count: 0
      },
      pop: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('user', ['user'])), {}, {
    wsData: function wsData() {
      var one = this.$store.getters['ws/group'].notice;
      return one ? one.data : [];
    },
    noMore: function noMore() {
      return this.noticeList.length >= this.list.count;
      // return this.noticeList.length >= 20
    },
    infiniteDisabled: function infiniteDisabled() {
      return this.loading || this.noMore;
    }
  }),
  watch: {
    wsData: {
      handler: function handler(val) {
        if (!val || !Object.keys(val).length) return;
        if (val.sendUserId !== 'noticeData') return;
        this.wsMessageDeal(val);
      },
      immediate: true
    },
    drawer: {
      handler: function handler(val) {
        if (!val) return;
        this.noticeList = [];
        this.refreshList();
      },
      immediate: true
    }
  },
  methods: {
    handlerClick: function handlerClick() {
      this.drawer = true;
    },
    getList: function getList() {
      /*
        createdTime: "2022-07-11 20:10:52"
        deptId: 1
        deptName: "义乌能源局"
        id: 116
        level: 1
        recvName: ""
        recvStatus: 0
        recvTime: "0001-01-01 00:00:00"
        sendContent: "降400kw负荷"
        sendDept: "义乌供电公司"
        sendTime: "2022-07-11 20:10:43"
        sendTitle: "test"
        updatedTime: "2022-07-11 20:10:52"
        */
      var that = this;
      this.loading = true;
      getNoticeList(this.queryParams).then(function (res) {
        setTimeout(function () {
          that.noticeList = that.noticeList.concat(res.data.list);
          that.loading = false;
        }, 2000);
        that.list.count = res.data.count;
      });
    },
    getInfo: function getInfo(id) {
      id = 12;
      getNoticeInfo(id).then(function (res) {
        // console.log('notice info', res)
      });
    },
    wsMessageDeal: function wsMessageDeal(wsdata) {
      if (wsdata.code !== 200) return;
      // console.log('ws notice', wsdata.data)
      if (this.pop) this.notifyWarn(wsdata.data.sendTitle, wsdata.data.sendContent, 0);
      this.alarmCount += 1;
    },
    infiniteLoad: function infiniteLoad() {
      this.queryParams.pageIndex += 1;
      this.getList();
    },
    refreshList: function refreshList() {
      this.queryParams = {
        pageIndex: 1,
        pageSize: 5
      };
      this.noticeList = [];
      this.getList();
    },
    handlerRead: function handlerRead(item) {
      var that = this;
      var param = _objectSpread(_objectSpread({}, item), {}, {
        recvStatus: 1,
        recvName: this.user.userName
      });
      updateNoticeInfo(param).then(function (res) {
        that.noticeList.forEach(function (item) {
          if (item.id !== res.data.id) return;
          item = res.data;
        });
      });
    },
    handlerPop: function handlerPop() {
      this.pop = !this.pop;
    }
  }
};